import React from 'react';
import { STEP_EDITOR_CONTENT_OPTION_URL } from 'src/editor/constants';
import { EditorContentFormAutocompleteInput } from 'src/editor/content-form/autocomplete-input';
import { useCurrentOrganization } from 'src/store/organization';
import { useStepEditorContext } from 'src/store/step-editor';

import { Content } from 'src/common/interfaces/content.interface';

import {
  CONTENT_SEARCH_OPTION_TYPE_DESTINATION,
  CONTENT_SEARCH_OPTION_TYPE_EXISTING_CONTENT,
  CONTENT_SEARCH_OPTION_TYPE_POPULAR_STARTS,
} from 'src/editor/constants';

interface StepEditorContentSearchBarProps {
  onUrlChange: (url: string) => void;
  onChooseExisting: (content: Content) => void;
}

const StepEditorContentSearch = ({ onUrlChange, onChooseExisting }: StepEditorContentSearchBarProps) => {
  const { setContentOption, setDestination } = useStepEditorContext();

  return (
    <EditorContentFormAutocompleteInput
      showExisting={true}
      onAutocompleteChange={(newValue: any) => {
        if (newValue) {
          const { type, value } = newValue;
          if (type === CONTENT_SEARCH_OPTION_TYPE_DESTINATION) {
            setContentOption(STEP_EDITOR_CONTENT_OPTION_URL);
            setDestination(value);
          } else if (type === CONTENT_SEARCH_OPTION_TYPE_EXISTING_CONTENT) {
            onChooseExisting(value);
          } else if (type === CONTENT_SEARCH_OPTION_TYPE_POPULAR_STARTS) {
            const { onClick } = value;
            onClick && onClick();
          }
        }
      }}
      onChange={onUrlChange}
      onPreviewNode={(node) => {}}
    />
  );
};

export default StepEditorContentSearch;
